module.exports = __webpack_public_path__ + "static/media/logo-without-text.9a8fa50b.png";